import React from "react"
import PropTypes from "prop-types"
import {
  Col,
  Row,
  Card,
  CardBody,
  Label,
  Input,
  Form,
  FormFeedback,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap"

const Step1SelectTarget = ({
  validation,
  pageView,
  countryOptions,
  panelOptions,
  showPanelModal,
  setShowPanelModal,
  getSelectedPanelImage,
  countriesWithPanels = [],
}) => {
  const getSelectedPanelName = () => {
    const selected = panelOptions.find(p => p.value === validation.values.panelOption)
    return selected ? selected.label : "Panel Detail"
  }

  // Get table data based on selected panel
  const getPanelTableData = () => {
    const panelName = getSelectedPanelName()
    
    // YJ Mid-Up Class Sample Pool
    if (panelName.includes("Mid-Up") || panelName.includes("mid-up")) {
      return [
        { id: 1, question: "No of Q <=30 ;", filter: "1", reward: "25", additional: "3" },
        { id: 2, question: "60>=No of Q > 30 ;", filter: "1.5", reward: "30", additional: "5" },
        { id: 3, question: "80>=No of Q > 60 ;", filter: "2.0", reward: "35", additional: "5" },
        { id: 4, question: "120>=No of Q > 80 ;", filter: "2.0", reward: "45", additional: "5" },
        { id: 5, question: "150>=No of Q > 120 ;", filter: "2.5", reward: "60", additional: "8" },
        { id: 6, question: "200 >=No of Q > 150 ;", filter: "2.5", reward: "70", additional: "10" },
        { id: 7, question: "No of Q > 200 ;", filter: "3", reward: "80", additional: "10" }
      ]
    }
    
    // YJ Common Consumer Sample Pool
    if (panelName.includes("Common") || panelName.includes("common") || panelName.includes("Consumer")) {
      return [
        { id: 1, question: "No of Q <=30 ;", filter: "-", reward: "12", additional: "2" },
        { id: 2, question: "60>=No of Q > 30 ;", filter: "-", reward: "15", additional: "2" },
        { id: 3, question: "80>=No of Q > 60 ;", filter: "-", reward: "18", additional: "3" },
        { id: 4, question: "120>=No of Q > 80 ;", filter: "-", reward: "20", additional: "3" },
        { id: 5, question: "150>=No of Q > 120 ;", filter: "-", reward: "25", additional: "5" },
        { id: 6, question: "200 >=No of Q > 150 ;", filter: "-", reward: "30", additional: "5" },
        { id: 7, question: "No of Q > 200 ;", filter: "-", reward: "40", additional: "5" }
      ]
    }
    
    // Default (Mid-Up)
    return [
      { id: 1, question: "No of Q <=30 ;", filter: "1", reward: "25", additional: "3" },
      { id: 2, question: "60>=No of Q > 30 ;", filter: "1.5", reward: "30", additional: "5" },
      { id: 3, question: "80>=No of Q > 60 ;", filter: "2.0", reward: "35", additional: "5" },
      { id: 4, question: "120>=No of Q > 80 ;", filter: "2.0", reward: "45", additional: "5" },
      { id: 5, question: "150>=No of Q > 120 ;", filter: "2.5", reward: "60", additional: "8" },
      { id: 6, question: "200 >=No of Q > 150 ;", filter: "2.5", reward: "70", additional: "10" },
      { id: 7, question: "No of Q > 200 ;", filter: "3", reward: "80", additional: "10" }
    ]
  }

  // Get panel introductions text based on selected panel
  const getPanelIntroductions = () => {
    const panelName = getSelectedPanelName()
    
    // YJ Mid-Up Class Sample Pool
    if (panelName.includes("Mid-Up") || panelName.includes("mid-up")) {
      return "The purpose of this survey is to gather insights from mid to upper-class consumers regarding their preferences, purchasing behavior, and lifestyle choices. We aim to understand their consumption patterns and decision-making processes to better serve their needs."
    }
    
    // YJ Common Consumer Sample Pool
    if (panelName.includes("Common") || panelName.includes("common") || panelName.includes("Consumer")) {
      return "The purpose of this survey is to understand the general consumer behavior and preferences across various product categories. We seek to gain insights into everyday purchasing decisions and consumption habits of the general population."
    }
    
    // Default
    return "The purpose of this interview is to understand the travel experiences of foreign tourists in Japan, to gain a deep understanding of their travel motivations, cultural adaptaion and overall satisfaction in Japan"
  }

  // Check if the selected country has panel options available
  const selectedCountry = validation.values.countryTarget
  const hasPanelOptions = countriesWithPanels.includes(selectedCountry)

  return (
    <>
      {/* Block 1: Select Target */}
      <Row>
        <Col>
          <Card style={{ borderRadius: "8px", overflow: "hidden" }}>
            <div
              className="p-3"
              style={{
                backgroundColor: "#E6F8F3",
                color: "#1a5d3a",
                fontWeight: "600",
                fontSize: "1.1rem",
                borderTopLeftRadius: "8px",
                borderTopRightRadius: "8px",
              }}
            >
              Select Target
            </div>
            <CardBody>
              <Form>
                <Row className="mb-3">
                  <Label htmlFor="countryTarget" className="col-md-2 col-form-label">
                    Country Target <span className="text-danger">*</span>
                  </Label>
                  <Col md={4}>
                    <Input
                      id="countryTarget"
                      name="countryTarget"
                      type="select"
                      className="form-control"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.countryTarget}
                      invalid={
                        validation.touched.countryTarget && validation.errors.countryTarget
                          ? true
                          : false
                      }
                      disabled={pageView === "view"}
                    >
                      {countryOptions.map(option => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </Input>
                    {validation.touched.countryTarget && validation.errors.countryTarget ? (
                      <FormFeedback type="invalid">
                        {validation.errors.countryTarget}
                      </FormFeedback>
                    ) : null}
                  </Col>
                </Row>
              </Form>
            </CardBody>
          </Card>
        </Col>
      </Row>

      {/* Block 2: Select Panel */}
      <Row>
        <Col>
          <Card style={{ borderRadius: "8px", overflow: "hidden" }}>
            <div
              className="p-3"
              style={{
                backgroundColor: "#E6F8F3",
                color: "#1a5d3a",
                fontWeight: "600",
                fontSize: "1.1rem",
                borderTopLeftRadius: "8px",
                borderTopRightRadius: "8px",
              }}
            >
              Select Panel
            </div>
            <CardBody>
              <Form>
                <Row className="mb-3">
                  <Label htmlFor="panelOption" className="col-md-2 col-form-label">
                    Panel Options <span className="text-danger">*</span>
                  </Label>
                  <Col md={4}>
                    {hasPanelOptions ? (
                      <>
                        <Input
                          id="panelOption"
                          name="panelOption"
                          type="select"
                          className="form-control"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.panelOption}
                          invalid={
                            validation.touched.panelOption && validation.errors.panelOption
                              ? true
                              : false
                          }
                          disabled={pageView === "view"}
                        >
                          {panelOptions.map(option => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </Input>
                        {validation.touched.panelOption && validation.errors.panelOption ? (
                          <FormFeedback type="invalid">
                            {validation.errors.panelOption}
                          </FormFeedback>
                        ) : null}
                        {validation.values.panelOption && (
                          <Button
                            type="button"
                            color="link"
                            className="p-0 mt-2"
                            onClick={() => setShowPanelModal(true)}
                          >
                            <i className="bx bx-show me-1"></i>
                            See more detail
                          </Button>
                        )}
                      </>
                    ) : (
                      <>
                        <p className={`mb-0 ${validation.touched.panelOption && validation.errors.panelOption ? 'text-danger' : 'text-muted'}`} style={{ paddingTop: "7px" }}>
                          {!selectedCountry 
                            ? "Please select a country first to see available panel options."
                            : "No panel options are available for the selected country yet."
                          }
                        </p>
                        {validation.touched.panelOption && validation.errors.panelOption && (
                          <div className="text-danger" style={{ fontSize: "0.875em", marginTop: "0.25rem" }}>
                            {validation.errors.panelOption}
                          </div>
                        )}
                      </>
                    )}
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Label className="col-md-2 col-form-label">
                    Panel Introductions
                  </Label>
                  <Col md={10}>
                    <p className="form-control-static" style={{ paddingTop: "7px", lineHeight: "1.6" }}>
                      {getPanelIntroductions()}
                    </p>
                  </Col>
                </Row>
              </Form>
            </CardBody>
          </Card>
        </Col>
      </Row>

      {/* Panel Detail Modal */}
      <Modal 
        isOpen={showPanelModal} 
        toggle={() => setShowPanelModal(false)} 
        centered
        size="lg"
      >
        <ModalHeader toggle={() => setShowPanelModal(false)}>
          {getSelectedPanelName()}
        </ModalHeader>
        <ModalBody className="p-0">
          <div>
            <div className="table-responsive">
              <table className="table table-bordered mb-0" style={{ fontSize: "14px" }}>
                <thead style={{ backgroundColor: "#f8f9fa" }}>
                  <tr>
                    <th className="text-center" style={{ width: "8%" }}>#</th>
                    <th style={{ width: "30%" }}>Number of Question</th>
                    <th className="text-center" style={{ width: "15%" }}>Filter</th>
                    <th className="text-center" style={{ width: "20%" }}>Reward</th>
                    <th className="text-center" style={{ width: "27%" }}>Additional Reward</th>
                  </tr>
                </thead>
                <tbody>
                  {getPanelTableData().map(row => (
                    <tr key={row.id}>
                      <td className="text-center">{row.id}</td>
                      <td>{row.question}</td>
                      <td className="text-center">{row.filter}</td>
                      <td className="text-center">{row.reward}</td>
                      <td className="text-center">{row.additional}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="px-3 py-2 d-flex justify-content-end" style={{ backgroundColor: "#fff", borderTop: "1px solid #E9EAEB" }}>
              <span style={{ fontSize: "12px", color: "#535862" }}>Unit: RMB/Person</span>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </>
  )
}

Step1SelectTarget.propTypes = {
  validation: PropTypes.object.isRequired,
  pageView: PropTypes.string,
  countryOptions: PropTypes.array.isRequired,
  panelOptions: PropTypes.array.isRequired,
  showPanelModal: PropTypes.bool.isRequired,
  setShowPanelModal: PropTypes.func.isRequired,
  getSelectedPanelImage: PropTypes.func.isRequired,
  countriesWithPanels: PropTypes.array,
}

export default Step1SelectTarget
